<script lang="ts">
  import Container from "./Container.svelte";
  import type { Justify, Spacing } from "./types.ts";
  export let gap: Spacing | undefined = undefined;
  export let justify: Justify | undefined = undefined;
  export let margin: Spacing | undefined = undefined;
  export let mobileMargin: Spacing | undefined = undefined;
  export let wrap = false;
  export let full = true;
  export let grow = false;
  export let outset = false;
</script>

<Container
  direction="col"
  {wrap}
  {gap}
  {justify}
  {margin}
  {full}
  {mobileMargin}
  {grow}
  {outset}
><slot /></Container>
